import { useMutation } from '@tanstack/react-query';
import { DEPRECATED_QUERY_KEYS, queryClient } from '@src/query';
import { ApiError } from '@src/services/api';
import { removeWidget } from './api';

export const useMutationRemoveWidget = () => useMutation<boolean, ApiError, {
  id: string
}>({
  mutationFn: ({ id }) => removeWidget(id),
  onSuccess: async () => {
    const key = [DEPRECATED_QUERY_KEYS.WIDGETS];
    queryClient.invalidateQueries({ queryKey: key });
    queryClient.refetchQueries({ queryKey: key });
  },
});
